/**
 * @fileoverview Tracing header constants
 * @module constants
 */

/**
 * W3C Trace Context and custom header names
 * @constant {Object}
 */
export const TRACE_HEADERS = Object.freeze({
  /** W3C Trace Context traceparent header */
  TRACEPARENT: 'traceparent',

  /** W3C Trace Context tracestate header */
  TRACESTATE: 'tracestate',

  /** Custom request ID header */
  REQUEST_ID: 'x-request-id',

  /** Custom tenant ID header for multi-tenant applications */
  TENANT_ID: 'x-tenant-id',

  /** Custom trace ID header (debug) */
  TRACE_ID: 'x-trace-id',

  /** Custom span ID header (debug) */
  SPAN_ID: 'x-span-id',

  /**
   * Page-scoped correlation id (PLN-BOARD-GATE-001 I-12). A trace is ONE
   * request (W3C / OTel), so the browser mints a fresh `traceparent` per
   * request; this header carries the PAGE's id on every one of them, which is
   * what joins a tab's requests — and its shipped browser logs — in Loki.
   */
  CORRELATION_ID: 'x-correlation-id',
});
